import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { SubfrotaService } from '../subfrota.service';
import { IFiltroSubFrotaModel, ISubFrotaModel } from '../model/subFrota.model';
@Component({
  selector: 'app-pesquisa-subfrota',
  templateUrl: './pesquisa-subfrota.component.html',
  styleUrls: ['./pesquisa-subfrota.component.scss']
})
export class PesquisaSubfrotaComponent implements OnInit, OnDestroy {
  usuario!: LoginModel | undefined;
  private subs = new Subscription();
  displayedColumns = ['codigo', 'codigoIdentificacao', 'descricao'];
  public dataSource!: MatTableDataSource<ISubFrotaModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = 0;
  filtro: IFiltroSubFrotaModel;

  constructor(
    private subfrotaService: SubfrotaService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private dialogRef: MatDialogRef<PesquisaSubfrotaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.filtro = {
      guid: '',
      coluna: '1',
      operador: 1,
      parametro: '',
      codigoFrota: data.codigoFrota
    };
  }

  ngOnInit(): void {
    this.usuario = this.authenticationService.getDadosUserLocal();
    if (this.usuario) {
      this.filtro.guid = this.usuario.retorno.guid;
      this.filtrar();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onSubmit() {
    this.filtrar();
  }

  limpaFiltro() {
    this.filtro.coluna = "1";
    this.filtro.operador = 1;
    this.filtro.parametro = "";
    this.dataSource = new MatTableDataSource<ISubFrotaModel>();
  }

  fechar() {
    this.dialogRef.close();
  }

  getRecord(row: ISubFrotaModel) {
    this.dialogRef.close({ data: row });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  private filtrar() {
    this.loading++;

    this.subs.add(
      this.subfrotaService.getSubFrotas(this.filtro).subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.dataSource = new MatTableDataSource<ISubFrotaModel>(res.retorno);
            this.dataSource.paginator = this.paginator;
            this.sort.sort(({ id: 'codigo', start: 'asc' }) as MatSortable);
            this.sort.disableClear = true;
            this.dataSource.sort = this.sort;
          }
        },
        complete: () => {
          this.loading--;
        }
      })
    );
  }
} 